import { render, staticRenderFns } from "./NewsletterSidebar.vue?vue&type=template&id=ec5805ba"
import script from "./NewsletterSidebar.vue?vue&type=script&lang=js"
export * from "./NewsletterSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports